module.exports = __webpack_public_path__ + "static/img/Asset_1@2x.123526d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asset_1@2x.png
// module id = hNOz
// module chunks = 1